/**
 * @file api-cabinet-themes.ts
 * @description Клиент тем кабинета (phase19.31): палитра шаблона темы.
 *
 *   GET /cabinet-themes/:id/palette — цвета шаблона; нужен только вход, прав
 *   не нужно (cabinet-api-contract.md §3). ETag и `Cache-Control: private,
 *   max-age=300` обрабатывает сам браузер. Неизвестный шаблон — 404
 *   `cabinet_theme_not_found`; палитра в базе не прошла проверку — сервер
 *   отдаёт «Commora» с `fallback: true`.
 *
 * Разделы платформы «Темы кабинета» и магазина «Оформление кабинета» —
 * следующими шагами фазы, их методы добавятся сюда.
 */

import { apiFetch } from "./api-client";
import type { CabinetPaletteDto } from "./cabinet-palette";

export function getCabinetThemePalette(themeId: string): Promise<CabinetPaletteDto> {
  return apiFetch<CabinetPaletteDto>(`/cabinet-themes/${encodeURIComponent(themeId)}/palette`);
}
